/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Req2Inputs */

const en_wc_on_req2 = /** @type {(inputs: Wc_On_Req2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A desktop or laptop screen. Phones work, but the ribbon is designed for a mouse and keyboard.`)
};

/**
* | output |
* | --- |
* | "A desktop or laptop screen. Phones work, but the ribbon is designed for a mouse and keyboard." |
*
* @param {Wc_On_Req2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_req2 = /** @type {((inputs?: Wc_On_Req2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Req2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_req2(inputs)
});
export { wc_on_req2 as "wc.on.req2" }